import { Button, Card, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export function NotFound() {
  const navigate = useNavigate();

  return (
    <Container>
      <Card>
        <Card.Body>
          <Card.Title>404</Card.Title>
          <Card.Text>Sorry this page does not exist</Card.Text>
          <Button onClick={() => navigate("/")}>Go home?</Button>
        </Card.Body>
      </Card>
    </Container>
  )
}
